import Editor from '@/components/editor/Editor.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { merge } from '@/utils/merge';
import { mapState } from 'vuex';
import { EventsTypesMinor } from '@/enums/EventsTypesMinor';
import { Resident } from '@/models/resident/Resident';
import firebase from 'firebase';
import moment from 'moment';
import { countByKeys } from '@/utils/countByKeys';
import ResidentCard from './components/ResidentCard.vue';
import { serializer } from '@/api/shared/serializer';
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import DownloadDlg from '@/components/popup/download-dialog/DownloadDlg.vue';
import Loader from "@/components/loader/Loader.vue";
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";
import { FamilyHubAppStatus } from '@/enums/FamilyHubAppStatus';
import { getRegionName } from '@/utils/functionsRegion';
import {v4 as uuidv4} from "uuid";
import juice from "juice";
import {EditorStyles} from "@/components/editor/EditorStyles";
import { getFormattedDateTimeString } from '@/utils/dateTimeFormat';
import { NotificationTypeEnum } from '@/enums/NotificationTypeEnum';
import { camelCaseToText } from '@/utils/stringFormat';
import Chat from '@/components/chat/Chat.vue'

export default {
  components: {
    Editor,
    ValidationObserver,
    ValidationProvider,
    ConfirmDlg,
    ResidentCard,
    DownloadDlg,
    Loader,
    Chat
  },
  data() {
    return {
      tab: null,
      editing: false,
      loading: true,
      isResidentLoading: false,
      dialog: false,
      submited: false,
      loadingNotifications: false,
      isAddingNotification: false,
      chatData: { familyMember: null },
      notificationForm: null,
      familyMemberForm: {
        name: '',
        email: '',
        phoneNumber: '',
      },
      headerNotifications: [
        {
          value: 'type',
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Type'],
          width: 200,
        },
        {
          value: 'title',
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Title'],
          width: 200,
        },
        {
          value: 'body',
          text: this.$i18n.messages[this.$i18n.locale]['FamilyView.Content'],
        }
      ],
      sendedMessages: [],
      periods: [
        {
          title: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Month'],
          value: 'month',
        },
        {
          title: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Week'],
          value: 'week',
        },
      ],
      period: 'week',
      familyMemberResidents: [],
      staffAccessLevels: StaffAccessLevels,
    };
  },

  async created() {
    try {
      this.initNotificationForm()
      await this.$store.dispatch('getFacility');

      await Promise.all([
        this.$store.dispatch('getFamilyMembers'),
        this.$store.dispatch('getFamilyMember', {
          id: this.$route.params.id,
          residentId: this.resident ? this.resident.id : null,
        }),
      ]);

      this.initChat()

      this.familyMemberCopy = {...this.familyMember}

      await this.$store.dispatch('getCalenderEventsByFamilyHubMemberId', {
        familyHubMemberId: this.$route.params.id,
        eventType: EventsTypesMinor.ScheduledCall,
      });
      await this.$store.dispatch(
        'getGuestbookVisitsByFamilyHubMemberId',
        this.$route.params.id
      );

      await this.$store.dispatch('getNotificationsFamilyMember', this.$route.params.id)

      await this.getResidents();

      this.familyMemberForm = merge(this.familyMemberForm, this.familyMember);

      await this.getSendedMessages();
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  },

  destroyed(): void {
    this.$store.commit('setCurrentFamilyMember', null);
    this.$store.commit('setCurrentResident', null);
  },

  computed: {
    ...mapState({
      broadcastTemplates: state => [
        {
          title: 'Not Selected',
          id: '',
        },
        ...(state as any).facilityModule.broadcastTemplates,
      ],
      familyHubMemberGuestbookVisits: state =>
        (state as any).guestbookModule.familyHubMemberGuestbookVisits,
      familyHubMemberEvents: state =>
        (state as any).calenderModule.familyHubMemberEvents,
      familyMemberNotifications: state => (state as any).notificationsModule.notificationsFamilyMember.map((notification) => {
        const notif = notification
        notif.type = camelCaseToText(notif.type)
        return notif
      }),
      residents(): Resident[] {
        return this.$store.state.residentModule.residentsShortData;
      },
      facility(state) {
        return (state as any).facilityModule.selectedFacility;
      },
    }),
    resident() {
      return this.$store.state.residentModule.currentResident;
    },
    familyMember() {
      const fm =  this.$store.state.residentModule.familyMembers.find(
        member => member.id === this.$route.params.id
      ) || {
        isCanInvite: false,
        invitedToFamilyApp: false,
        residentConsent: false
      };
      const access = fm?.staffControlledFamilyAccesses;
      fm.staffControlledFamilyAccesses = {
        activities: access?.activities ?? true,
        care: access?.care ?? (this.facility?.isEnableCareTab ?? false),
        careNotes:  false,
        careSummary: access?.careSummary ?? (this.facility?.isCareSummary ?? false),
        chat: access?.chat ?? true,
        concierge: access?.concierge ?? true,
        conciergeEvents: access?.conciergeEvents ?? true,
        dailyCare:access?.dailyCare ?? (this.facility?.isDailyCare ?? false),
        dailyPlan: access?.dailyPlan ?? (this.facility?.isDailyPlan ?? false),
        carePlan: access?.carePlan ?? ((this.facility?.isCarePlan && this.facility?.isEnabledCarePlan) ?? false),
        instantCalls: access?.instantCalls ?? true,
        lifestyle: access?.lifestyle ??true,
        lifestyleEvents: access?.lifestyleEvents ?? true,
        noticeboard: access?.noticeboard ??true,
        scheduledCalls:access?.scheduledCalls ?? true,
      }

      console.log(fm)
      return fm;
    },
    isSendButtonEnabled() {
      return (
        this.notificationForm.sendByEmail || this.notificationForm.sendByPush
      );
    },
    sendedMessagesByDates() {
      return this.createDatesRange();
    },
    user() {
      return this.$store.state.authModule.user;
    },
    canDelete() {
      if(this.user) {
        return this.user?.accessLevel === this.staffAccessLevels.OrgAdmin || this.user?.accessLevel === this.staffAccessLevels.FacilityAdmin;
      } else {
        return false;
      }
    }
  },

  watch: {
    ['notificationForm.templateId'](value, oldValue) {
      if (value) {
        const template = this.broadcastTemplates.find(
          template => template.id === value
        );
        this.notificationForm.html = template.html ?? '';
        this.notificationForm.subject = template.subject ?? '';
      } else {
        this.notificationForm.html = '';
        this.notificationForm.subject = '';
      }
    },
  },

  methods: {
    initChat(){
      if(this.facility.canStaffMessageFamily){
        this.chatData.familyMember = this.familyMember
      }
    },
    initNotificationForm(){
      this.notificationForm = {
        html: '',
        type: NotificationTypeEnum.FamilyNotification,
        templateId: '',
        subject: '',
        sendByEmail: false,
        sendByPush: false,
      }
    },
    edit() {
      this.editing = !this.editing;
    },

    async updateFamilyMember() {
      this.submited = true;

      this.familyMember.invitedToFamilyApp = this.familyMember.invitedToFamilyApp || false


      if(this.familyMember.invitedToFamilyApp && !this.familyMember.lastActive) {
        this.familyMember.appStatus = FamilyHubAppStatus.Pending;
      } else if(!this.familyMember.invitedToFamilyApp && !this.familyMember.lastActive) {
        this.familyMember.appStatus = FamilyHubAppStatus.NotAdded;
      } else if(this.familyMember.invitedToFamilyApp && this.familyMember.lastActive) {
        this.familyMember.appStatus = FamilyHubAppStatus.Activated;
      } else {
        this.familyMember.appStatus = FamilyHubAppStatus.ReadOnly;
      }

      if(this.familyMemberForm.email != this.familyMember.email){
        this.familyMemberForm.oldEmailAddress = this.familyMember.email
      }

      const residentIds = this.familyMemberResidents.map(resident => {
        return resident.id
      })

      await this.$store.dispatch('updateFamilyMember', {
        id: this.familyMember.id, 
        data: {
          ...this.familyMemberForm,
          invitedToFamilyApp: this.familyMember.invitedToFamilyApp,
          appStatus: this.familyMember?.appStatus,
          isCanInvite: this.familyMember.isCanInvite || false,
          residentIds: residentIds,
          staffControlledFamilyAccesses: this.familyMember?.staffControlledFamilyAccesses,
          residentConsent: this.familyMember.residentConsent || false,
         }
        })

      this.familyMemberCopy = {...this.familyMember}
      this.submited = false;
      this.editing = false;
    },

    async sendNotification() {
      this.isAddingNotification = true;

      await this.rulesForResidentName();
      await this.rulesForFamilyMemberName();
      await this.rulesForFamilyMemberImage();
      await this.rulesForFamilyMemberEmail();
      await this.rulesForPasswordLink();
      await this.checkNotificationType();

      await this.$store.dispatch('sendNotificationToFamilyMember', { familyMember: this.familyMember, ...this.notificationForm })
        .then(async(res) => {
          if(res.data.status === 200){
            this.loadingNotifications = true;
            setTimeout(async() => {
              await this.$store.dispatch('getNotificationsFamilyMember', this.$route.params.id)
              this.$forceUpdate();
              this.loadingNotifications = false;
            }, 1000);
          }
        }).finally(() => {
          this.closeNotificationDialog()
          this.isAddingNotification = false;
        })
        .catch(e => {
          this.closeNotificationDialog()
        })
    },

    closeNotificationDialog() {
      this.dialog = false;
      this.initNotificationForm();
      this.$refs.notificationObserver.reset();
    },

    async checkNotificationType() {
      if(this.notificationForm.sendByEmail) {
        this.notificationForm.html = juice.inlineContent(this.notificationForm.html || '', EditorStyles);
      }
    },

    async rulesForResidentName() {
      if(this.notificationForm.html.includes("residentName")) {
        const residents = this.familyMember.residents;
        const fields = ["{{residentName}}", "{{ residentName }}"]
        let residentsNames = "";

        residents.forEach((resident, index) => {
          if(residents.length-1 > index) {
            residentsNames += `${resident.name} and `
          } else {
            residentsNames += `${resident.name}`
          }
        })

        fields.forEach((x) => {
          this.notificationForm.html = this.notificationForm.html.replace(x, residentsNames)
        });
      }
    },

    async rulesForFamilyMemberName() {
      if(this.notificationForm.html.includes("familyUserName") || this.notificationForm.html.includes("familyMemberName")) {
        const fields = ["{{familyUserName}}", "{{ familyMemberName }}"]
        const familyMemberName = this.familyMember?.name;

        fields.forEach((x) => {
          this.notificationForm.html = this.notificationForm.html.replace(x, familyMemberName)
        });
      }
    },

    async rulesForFamilyMemberImage() {
      if(this.notificationForm.html.includes("familyMemberImageUrl") || this.notificationForm.html.includes("familyUserImageUrl")) {
        const fields = ["{{familyMemberImageUrl}}", "{{ familyMemberImageUrl }}", "{{familyUserImageUrl}}", "{{ familyUserImageUrl }}"]
        const familyMemberImage = this.familyMember?.imageUrl;

        fields.forEach((x) => {
          this.notificationForm.html = this.notificationForm.html.replace(x, familyMemberImage)
        });
      }
    },

    async rulesForFamilyMemberEmail() {
      if(this.notificationForm.html.includes("familyMemberEmail") || this.notificationForm.html.includes("familyUserEmail")) {
        const fields = ["{{familyMemberEmail}}", "{{ familyMemberEmail }}", "{{familyUserEmail}}", "{{ familyUserEmail }}"]
        const familyMemberEmail = this.familyMember?.email;

        fields.forEach((x) => {
          this.notificationForm.html = this.notificationForm.html.replace(x, familyMemberEmail)
        });
      }
    },

    async rulesForPasswordLink() {
      if(this.notificationForm.html.includes("setPasswordLink")) {
        const passwordToken = uuidv4();
        const baseUrl = this.$store.state.facilityModule.selectedFacility.baseUrl;
        const to = this.familyMember?.email;

        if(!this.familyMember.setPasswordToken) {
          console.log("SEND INVITE")
          firebase.firestore().collection("familyHubUsers").doc(this.familyMember.id).update({
            setPasswordToken: passwordToken,
            invitationSentDateTime: firebase.firestore.Timestamp.fromDate(new Date()),
          }).then(() => {
            const setPasswordLink = `https://${baseUrl}/familyhub/set-password/${passwordToken}`;
            firebase
              .firestore()
              .collection('email')
              .add({
                from: "no-reply@getreshub.com",
                to: to,
                facilityId: this.$store.state.authModule.currentFacility,
                message: {
                  subject: "Create new password",
                  html: `<a href="${setPasswordLink}">Create New Password</a>`
                }
              })
          })
        }

        if(this.familyMember.setPasswordToken && this.familyMember.appStatus !== FamilyHubAppStatus.Activated) {
          console.log("SET PASSWORD")
          firebase.firestore().collection("familyHubUsers").doc(this.familyMember.id).update({
            setPasswordToken: passwordToken
          }).then(() => {
            const setPasswordLink = `https://${baseUrl}/familyhub/set-password/${passwordToken}`;
            firebase
              .firestore()
              .collection('email')
              .add({
                from: "no-reply@getreshub.com",
                to: to,
                facilityId: this.$store.state.authModule.currentFacility,
                message: {
                  subject: "Set new password",
                  html: `<a href="${setPasswordLink}">Set New Password</a>`
                }
              })
          })
        }

        if(this.familyMember.setPasswordToken && this.familyMember.appStatus === FamilyHubAppStatus.Activated) {
          console.log("RESET PASSWORD")
          firebase.firestore().collection("familyHubUsers").doc(this.familyMember.id).update({
            resetPasswordToken: passwordToken
          }).then(() => {
            const resetPasswordLink = `https://${baseUrl}/familyhub/reset-password/${passwordToken}`;
            firebase
              .firestore()
              .collection('email')
              .add({
                from: "no-reply@getreshub.com",
                to: to,
                facilityId: this.$store.state.authModule.currentFacility,
                message: {
                  subject: "Reset password",
                  html: `<a href="${resetPasswordLink}">Reset Password</a>`
                }
              })
          })
        }
      }
    },

    async getSendedMessages() {
      firebase
        .firestore()
        .collection('messages')
        .where('facilityId', '==', this.facility.id)
        .where('familyHubUserId', '==', this.$route.params.id)
        .where('from', '==', 'family')
        .where('to', '==', 'resident')
        .where('createdAt', '<=', moment().unix() * 1000)
        .where(
          'createdAt',
          '>=',
          moment()
            .subtract(1, this.period)
            .unix() * 1000
        )
        .get()
        .then(qs => {
          this.sendedMessages = qs.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));
        })
        .catch(e => {
          console.error(e);
        });
    },

    createDatesRange() {
      const start = moment().subtract(1, this.period);
      const end = moment();
      const format = 'DD/MM';

      const countedMessagesByDates = countByKeys(
        this.sendedMessages.map(event => ({
          ...event,
          createdAt: moment.unix(event?.createdAt / 1000).format(format),
        })),
        'createdAt'
      );

      const current = end.clone();
      const dates = [];

      while (current.isAfter(start)) {
        dates.push(current.format(format));

        current.subtract(1, 'days');
      }

      const result = dates.reverse().reduce((total, current) => {
        total[current] = countedMessagesByDates[current]
          ? countedMessagesByDates[current]
          : 0;

        return total;
      }, {});

      return result;
    },

    async getResidents() {
      const residentIds = this.familyMember?.residentIds || [];

      try {
        if (!residentIds || residentIds.length === 0) {
          return [];
        }

        if (!this.facility || !this.facility.id) {
          return [];
        }

        const residents = await firebase
          .firestore()
          .collection('residents')
          .where('facilityId', '==', this.facility.id)
          .where(firebase.firestore.FieldPath.documentId(), 'in', residentIds)
          .get();

        this.familyMemberResidents = serializer.querySnapshotToDocuments(
          residents
        );
      } catch (e) {
        console.log(e);
      }
    },

    isFamilyUserFinancialEPOA(resident) {
      const result = this.familyMember.financialEPOA || [];

      return result.find(x => x.id === resident.id)?.status || false;
    },

    isFamilyUserEnduringPOA(resident) {
      const result = this.familyMember.enduringPOA || [];

      return result.find(x => x.id === resident.id)?.status || false;
    },

    isFamilyUserWelfarePOA(resident) {
      const result = this.familyMember.welfarePOA || [];

      return result.find(x => x.id === resident.id)?.status || false;
    },

    relationshipToResident(resident) {
      return resident.familyHubUsers.find(x => x.id === this.familyMember.id)?.relationship;
    },

    async handleChangeFamilyResidentData(data) {
      this.isResidentLoading = true;

      try {

        let financialEPOA = this.familyMember?.financialEPOA || []
        let welfarePOA = this.familyMember?.welfarePOA || []
        let enduringPOA = this.familyMember?.enduringPOA || []

        if(data.isWelfarePOA){
          const result = {
            id: data.isWelfarePOA.id,
            status: data.isWelfarePOA.status
          }
          const filtered = welfarePOA.filter(f => f.id !== data.isWelfarePOA.id) || []
          welfarePOA = [result, ...filtered]
        }

        if(data.isFinancialEPOA){
          const result = {
            id: data.isFinancialEPOA.id,
            status: data.isFinancialEPOA.status
          }
          const filtered = financialEPOA.filter(f => f.id !== data.isFinancialEPOA.id) || []
          financialEPOA = [result, ...filtered]
        }

        if(data.isEnduringPOA){
          const result = {
            id: data.isEnduringPOA.id,
            status: data.isEnduringPOA.status
          }
          const filtered = enduringPOA.filter(f => f.id !== data.isEnduringPOA.id) || []
          enduringPOA = [result, ...filtered]
        }

        const staffControlledFamilyAccesses = this.reconfigureAppAccess(data?.isEnduringPOA?.status)

        await firebase
          .firestore()
          .collection('familyHubUsers')
          .doc(this.familyMember.id)
          .update({
            financialEPOA: financialEPOA,
            welfarePOA: welfarePOA,
            enduringPOA: enduringPOA,
            staffControlledFamilyAccesses: staffControlledFamilyAccesses
          });

        await this.$store.dispatch('getFamilyMembers');
        await this.$store.dispatch('getFamilyMember', {
          id: this.$route.params.id,
          residentId: this.resident ? this.resident.id : null,
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.isResidentLoading = false;
      }
    },

    reconfigureAppAccess(isEnduringPOA){

      if(!isEnduringPOA === null || typeof isEnduringPOA === 'undefined'){
        return this.familyMember.staffControlledFamilyAccesses
      }

      if(isEnduringPOA
          && this.$store.state.facilityModule.selectedFacility?.isEnableCareTab === true 
          && this.$store.state.facilityModule.selectedFacility?.isEnabledCarePlan){
          this.familyMember.staffControlledFamilyAccesses.care = true
          this.familyMember.staffControlledFamilyAccesses.carePlan = true
          return this.familyMember.staffControlledFamilyAccesses
      }
      else{
          return this.familyMember.staffControlledFamilyAccesses
      }
    },

    async handleChangeNextOfKin(data) {
      this.isResidentLoading = true;

      try {
        const resident = this.familyMemberResidents.find(x => x.id === data.id);
        const familyMember = resident.familyHubUsers.find(x => x.id === this.familyMember.id);
        let familyMembers = resident.familyHubUsers;
        const familyMembersFiltered = familyMembers.filter(x => x.id !== this.familyMember.id);

        familyMember.isNextOfKin = data.isNextOfKin;
        familyMembers = [familyMember, ...familyMembersFiltered];

        await firebase
          .firestore()
          .collection('residents')
          .doc(data.id)
          .update({
            familyHubUsers: familyMembers,
          });
        await this.$store.dispatch('getFamilyMembers');
        await this.$store.dispatch('getFamilyMember', {
          id: this.$route.params.id,
          residentId: this.resident ? this.resident.id : null,
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.isResidentLoading = false;
      }
    },

    resetPassword(): void {
      (this.$refs.confirmationModal as any)
        .open(
          null,
          this.$t('UserDetails.ResetPasswordEmailQuestion'),
          false,
          "",
          null,
          this.$t('UserDetails.PasswordHasBeenResetMessage')
        )
        .then(async response => {
          if (response && response.agree) {
             firebase.app().functions(getRegionName()).httpsCallable('familyUser-resetFamilyUserPassword')({
              familyUserId: this.$route.params.id,
            });
            this.$toast.open({ message: 'Password reset email has been sent', type: "success" });
          }
        });
    },

    sendVerificationLink(): void {
      if(!this.familyMember.invitedToFamilyApp) return

      (this.$refs.confirmationModal as any)
        .open(
          null,
          (this.$i18n.messages[this.facility.languageIso]['FamilyView.SendVerificationMessage']).replace('[FamilyMemberName]', this.familyMember.name),
          false
        )
        .then(async response => {
          if (response && response.agree) {
            const result = await firebase.app().functions(getRegionName()).httpsCallable('familyUser-sendFamilyVerificationEmail')({
              email: this.familyMember.email,
            });

            if(result.data.status === 200){
              this.$toast.open({ message: this.$i18n.messages[this.facility.languageIso]['FamilyView.VerificationEmailHasBeenSent'], type: "success" });
            }
            else{
              this.$toast.open({ message: this.$i18n.messages[this.facility.languageIso]['FamilyView.UnableToSendVerificationEmail'], type: "error" });
            }
          }
        });
    },

    openFamilyDownload() {
      (this.$refs.DownloadDlg as any).open(this.familyMember, this.familyMemberResidents, "family");
    },

    isNextOfKin(resident) {
      return resident.familyHubUsers.find(x => x.id === this.familyMember.id)?.isNextOfKin || false;
    },

    deleteFamilyMember() {
      (this.$refs.confirmationModal as any)
        .open(
          null,
          this.$i18n.messages[this.facility.languageIso]['FamilyView.DeleteMessage'],
          false,
          "",
          null,
          this.$i18n.messages[this.facility.languageIso]['FamilyView.FamilyMemberHasBeenDeleted']
        )
        .then(response => {
          if (response && response.agree) {
            this.$store.dispatch('deleteFamilyHubUserFromProfile', this.familyMember.id).then(() => {
              this.$router.push("/family-members")
            })
          }
        });
    },
    formattedDateTimeString(date: Date, addYears: boolean, addTime: boolean) {
      if(!this.facility) return ''

      return getFormattedDateTimeString(date, this.facility.dateFormat, addTime?this.facility.timeFormat: null, addYears);
    }
  }
};
